import React, { useContext } from "react"
import { LanguageContext } from "../hooks/use-language"

const Language = ({ id }) => {
  const { language, switchLanguage } = useContext(LanguageContext)

  if (!language) {
    return null
  }

  return (
    <button
      onClick={() => switchLanguage(language === "fi" ? "en-US" : "fi")}
      disabled={id === language}
      className={`language-switcher__button ${language.toLowerCase().includes(id.toLowerCase()) ? "disabled" : ""}`}
      aria-label={language === "fi" ? "Suomeksi" : "English"}
    >
      {id.toUpperCase()}
    </button>
  )
}

export default Language
